<template>
  <div class="event-layout">
    <Event
      v-for="event in this.eventList"
      v-bind:key="event.id"
      :id="event.id"
      :title="event.name"
      :dateStart="event.startDate"
      :price="event.price"
      :description="event.description"
      :hall-type="event.hallType"
      :img-path="event.image.path"/>
  </div>
</template>

<script>
import Event from './Event.vue'
import axios from 'axios'
import apiClient from "../../apiClient";

export default {
  name: 'EventLayout',
  components: {Event},
  created: function () {
    // TODO сделать loader
    let that = this

    apiClient.get('/api/event/all').then(response => {
      that.eventList = response.data
    }).catch(error => {
      console.error('Error fetching events', error)
    })
  },
  data () {
    return {
      eventList: []
    }
  }
}
</script>

<style scoped>
.event-layout {
  display: flex;
  flex: 1;
  overflow-y: auto;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 30px;
  padding: 50px 0;
}

.event-layout::-webkit-scrollbar {
  width: 8px;
  background: #FFFFFF;
}

.event-layout::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: #5d5d62;
}
</style>



// WEBPACK FOOTER //
// src/components/client/EventLayout.vue